import ButtonSimple from 'app/ui/buttons/ButtonSimple';

export default class OverlayMacroView extends Phaser.Group {
  constructor({ game, macroView, x, y, furniture, animInd }) {
    super(game);

    this.macroView = macroView;
    this.furniture = furniture; // the furniture connected with macro view
    this.animInd = animInd;

    this.onClose = new Phaser.Signal();

    // background
    this.bg = this.game.make.graphics();
    this.bg.beginFill(0, 0.7);
    this.bg.drawRect(0, 0, this.game.defaultWidth, this.game.defaultHeight);
    this.bg.endFill();
    this.bg.inputEnabled = true;
    this.bg.input.useHandCursor = false;
    this.bg.alpha = 0;
    this.addChild(this.bg);

    // btn back
    this.btnBack = new ButtonSimple({
      game: this.game,
      up: 'btn_back',
      over: 'btn_back',
    });
    this.btnBack.x = 60;
    this.btnBack.y = 60;
    this.addChild(this.btnBack);

    this.createMagnifier({ x, y, macroView });

    // anims
    this.game.add.tween(this.bg).to({ alpha: 1 }, 300, null, true);
    this.game.add
      .tween(this.container.scale)
      .to({ x: 1, y: 1 }, 300, Phaser.Easing.Quadratic.Out, true);
    this.game.add
      .tween(this.container)
      .to(
        { x: this.game.width / 2, y: this.game.height / 2 },
        300,
        Phaser.Easing.Quadratic.Out,
        true
      );

    this.game.add
      .tween(this.rootBone)
      .to({ scaleX: 1, scaleY: 1 }, 300, Phaser.Easing.Quadratic.Out, true)
      .onComplete.add(this.onShow, this);

    //
    this.game.sounds.playSFX('generic_reveal', { spriteID: 'sfx' });

    this.game.time.events.add(300, this.playSfx, this);
  }

  onShow() {
    this.btnBack.onInputDown.add(this.handleBtnBack, this);
    this.bg.events.onInputDown.add(this.handleBtnBack, this);
  }

  createMagnifier({ x, y, macroView }) {
    // container for magnifier and content
    this.container = this.game.make.group();
    this.container.x = x;
    this.container.y = y;
    this.container.scale.set(0.16);
    this.addChild(this.container);

    // magnifier
    this.magnifier = this.game.make.image(0, 0, 'magnifier');
    this.magnifier.anchor.set(0.39, 0.385);
    this.magnifier.inputEnabled = true;
    this.magnifier.input.pixelPerfectAlpha = 10;
    this.magnifier.input.pixelPerfectClick = true;
    this.container.addChild(this.magnifier);

    // content
    this.content = this.game.make.spine(0, 0, macroView.contentId, true);
    this.content.anchor.set(0.5, 1);
    this.content.setAnimationByName(0, macroView.animNames[this.animInd], true);
    this.container.addChildAt(this.content, 0);
    this.rootBone = this.content.skeleton.getRootBone();
    this.rootBone.scaleX = 0.16;
    this.rootBone.scaleY = 0.16;
  }

  playSfx() {
    if (this.macroView.audio) {
      this.game.sounds.playSFX(this.macroView.audio, { spriteID: 'sfx', loop: true });
    }

    this.content.onEvent.add(this.handleAudioEvent, this);
  }

  handleAudioEvent(track, event) {
    track;
    this.game.sounds.playSFX(event.data.name, { spriteID: 'sfx' });
  }

  handleBtnBack() {
    this.furniture.onCloseMacroView();
    this.onClose.dispatch();
  }

  positionElements() {
    this.container.x = this.game.width / 2;
    this.container.y = this.game.height / 2;
  }

  destroy() {
    this.content.onEvent.remove(this.handleAudioEvent, this);

    if (this.macroView.audio) {
      this.game.sounds.stopAudioSprite(this.macroView.audio, { spriteID: 'sfx' });
    }

    super.destroy();
  }
}
